import { lazy } from "react";
import AuthGuard from "routes/AuthGuard";
import Loadable from "routes/Loadable";
import AdminLayout from "components/layouts/adminLayout";

//staff
const Staff = Loadable(lazy(() => import("pages/staff")));
const Details = Loadable(lazy(() => import("pages/staff/Details")));
const PaymentCategory = Loadable(lazy(() => import("pages/staff/PaymentCategory")));
const AddPayment = Loadable(lazy(() => import("pages/staff/PaymentAdd")));
const Payments = Loadable(lazy(() => import("pages/staff/Payments")));

const StaffRoutes = {
  path: "staff",
  element: (
    <AuthGuard>
      <AdminLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "list",
      element: <Staff />,
    },
    {
      path: "details/:id",
      element: <Details />,
    },
    {
      path: "payment-category",
      element: <PaymentCategory />,
    },
    {
      path: "add-payment",
      element: <AddPayment />,
    },
    {
      path: "payments",
      element: <Payments />,
    },
  ],
};

export default StaffRoutes;
